import React from 'react';
import {Form, Input, Select, Button, Row, Col, Badge} from 'antd';
import _ from 'lodash';

import {useGetFilterOptionsQuery} from '../../../store/api/ticketsApi';

import {TicketFilterProps, TicketStatus, ticketStatusColors} from '../../../types/ticketTypes';
import {messageType, showMessages} from '../../../helpers/message';
import {BaseError} from '../../../types/apiTypes';
import {filterFormActionsColLayout, filterFormColLayout} from '../../../assets/styles';

import './TicketFilter.less';

const {Option} = Select;

const TicketFilter = ({onSearch, onReset}: TicketFilterProps) => {
    const [form] = Form.useForm();
    const {data: filterOptions, isLoading: filterOptionsLoading, isError, error} = useGetFilterOptionsQuery();

    React.useEffect(() => {
        if (isError && error) {
            showMessages((error as BaseError).data?.message, messageType.error);
        }
    }, [error, isError]);

    const handleReset = () => {
        form.resetFields();
        onReset();
    };

    return (
        <Form
            form={form}
            layout="horizontal"
            onFinish={onSearch}
            className="ticket-filter-form"
        >
            <Row gutter={16}>
                <Col {...filterFormColLayout}>
                    <Form.Item name="account_membership_number" label="Account #">
                        <Input placeholder="Type account number here"/>
                    </Form.Item>
                </Col>
                <Col {...filterFormColLayout}>
                    <Form.Item name="regarding_first_name" label="First Name">
                        <Input placeholder="Type first name here"/>
                    </Form.Item>
                </Col>
                <Col {...filterFormColLayout}>
                    <Form.Item name="regarding_last_name" label="Last Name">
                        <Input placeholder="Type last name here"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col {...filterFormColLayout}>
                    <Form.Item name="type" label="Ticket Type">
                        <Select placeholder="Select ticket type" loading={filterOptionsLoading}>
                            {filterOptions?.types?.map((type) => (
                                <Option key={type} value={type}>
                                    {_.upperFirst(type)}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col {...filterFormColLayout}>
                    <Form.Item name="status" label="Status">
                        <Select placeholder="Select context" loading={filterOptionsLoading}>
                            {filterOptions?.statuses?.map((status) => (
                                <Option key={status} value={status}>
                                    <Badge
                                        className="status-badge-style"
                                        color={ticketStatusColors[status as TicketStatus]}
                                        text={_.startCase(status)}
                                        dot
                                    />
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col {...filterFormColLayout}>
                    <Form.Item name="context" label="Context">
                        <Select placeholder="Select context" loading={filterOptionsLoading}>
                            {filterOptions?.contexts?.map((context) => (
                                <Option key={context} value={context}>
                                    {_.upperFirst(context)}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col {...filterFormActionsColLayout} className="ticket-filter-buttons-row">
                    <Row justify="end" align="middle" gutter={8}>
                        <Button type="default" onClick={handleReset}>
                            Reset
                        </Button>
                        <Button type="primary" htmlType="submit">
                            Search
                        </Button>
                    </Row>
                </Col>
            </Row>
        </Form>
    );
};

export default TicketFilter;
